import { render, staticRenderFns } from "./ArticleDetail.vue?vue&type=template&id=4c754684&scoped=true&"
import script from "./ArticleDetail.vue?vue&type=script&lang=js&"
export * from "./ArticleDetail.vue?vue&type=script&lang=js&"
import style0 from "./ArticleDetail.vue?vue&type=style&index=0&id=4c754684&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c754684",
  null
  
)

export default component.exports